export class OsmTileVersion {
  constructor(public readonly id: number, public readonly tileVersion: string, public readonly publicationDate: Date) {}
}



// WEBPACK FOOTER //
// ./src/app/models/osmtileversion.model.ts